import { render, staticRenderFns } from "./edit-vehicle-form.vue?vue&type=template&id=5d6c0476&scoped=true&"
import script from "./edit-vehicle-form.vue?vue&type=script&lang=js&"
export * from "./edit-vehicle-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6c0476",
  null
  
)

export default component.exports